import { Text } from '@vimeo/bokeh';
import { IBaseDomElementProps } from '@vimeo/core/types/dom';

import { createDomName } from '../../../../utils/dom/identifying';
import { BokehTooltip } from '../../../bokeh';

interface IChatMessageAuthorProps extends IBaseDomElementProps {
  isCurrentSender: boolean;
  senderName: string;
}

export function ChatMessageAuthor({
  className = createDomName('chat-message-author'),
  senderName,
}: IChatMessageAuthorProps) {
  return (
    <BokehTooltip placement={'bottom'} label={senderName} shouldWrapChildren={false}>
      <Text
        className={className}
        variant={'heading-xs'}
        textOverflow={'ellipsis'}
        whiteSpace={'nowrap'}
        overflow={'hidden'}
        maxWidth={'100%'}
      >
        {senderName}
      </Text>
    </BokehTooltip>
  );
}
